let {Card} = require('./card');

export class Board {
    constructor(cards) {
        if (!Array.isArray(cards)) {
            throw Error('Cards must be Array');
        }
        cards.forEach(function(card) {
            if (!(card instanceof Card)) {
                throw Error('Card array elements must be Card object');
            }
        });
        this.cards = cards;
    }
}
